/*!
 * CHIEF - Cybersecurity Learning Platform (PROPRIETARY SOFTWARE)
 * Page Notifications Hook
 * 
 * Copyright (c) 2025 Srivatsan Sk. All rights reserved.
 * 
 * PROPRIETARY LICENSE NOTICE:
 * This software is the exclusive proprietary property of Srivatsan Sk.
 * Licensed to client under strict commercial license agreement.
 * Unauthorized use, copying, modification, distribution, or removal
 * of copyright notices is strictly prohibited.
 * 
 * Original Author: Srivatsan Sk
 * License: Proprietary/Commercial
 * Status: Confidential
 * 
 * WARNING: This code contains proprietary business logic and algorithms.
 * Reverse engineering, decompilation, or derivative works are prohibited.
 */

import { useEffect } from 'react';
import { useNotifications } from '../contexts/NotificationContext';

/**
 * Custom hook to manually refresh notifications when needed
 * @param {boolean} autoRefresh - Whether to automatically refresh on mount (default: false)
 * @param {number} delay - Delay in milliseconds before refreshing (default: 0)
 */
export const usePageNotifications = (autoRefresh = false, delay = 0) => {
    const { refreshNotificationsIfNeeded, forceRefreshNotifications } = useNotifications();

    useEffect(() => {
        if (autoRefresh) {
            const timer = setTimeout(() => {
                refreshNotificationsIfNeeded();
            }, delay);

            return () => clearTimeout(timer);
        }
    }, [autoRefresh, delay, refreshNotificationsIfNeeded]);

    // Return functions for manual control
    return {
        refreshNotificationsIfNeeded,
        forceRefreshNotifications
    };
};

export default usePageNotifications;
